import SignUpForm from "../../components/auth/SignUpForm";
import { env } from "../../env";
import useAuth from "../../hooks/useAuth";
import logoBlack from "../../vendor/logo_black.svg";
import logoWhite from "../../vendor/logo_white.svg";
import { Alert as MuiAlert, Paper, Typography } from "@mui/material";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { spacing } from "@mui/system";
import { useSignUpMutation } from "generated.hooks";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";

const Alert = styled(MuiAlert)(spacing);

const Brand = styled("img")`
  width: 250px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignIn() {
  const navigate = useNavigate();
  const [signUp, { loading, error }] = useSignUpMutation();
  const { signIn } = useAuth();
  const theme = useMuiTheme();
  const brandSrc = theme.palette.mode === "dark" ? logoWhite : logoBlack;
  const turnstileEnabled = Boolean(env.REACT_APP_TURNSTILE_SITE_KEY);

  return (
    <React.Fragment>
      <Brand alt="Podium" src={brandSrc} />
      <Wrapper>
        <Helmet title="Sign Up" />
        <Typography component="h2" variant="body1" align="center">
          Create a new account
        </Typography>
        {error && (
          <Alert mt={2} mb={3} severity="warning">
            Internal server error
          </Alert>
        )}
        <SignUpForm
          initialValues={{
            accountName: "",
            firstName: "",
            lastName: "",
            email: "",
            password1: "",
            password2: "",
            turnstileToken: "",
          }}
          onSubmit={(data, { setErrors, setFieldValue, setSubmitting }) => {
            return signUp({
              variables: data,
            })
              .then(async (res) => {
                if (res.data?.registerWithAccount.success) {
                  if (turnstileEnabled) {
                    navigate("/auth/sign-in");
                  } else {
                    await (signIn as any)(data.email, data.password1);
                    navigate("/");
                  }
                } else {
                  setFieldValue("turnstileToken", "", false);
                  setErrors(
                    Object.keys(res.data?.registerWithAccount.errors).reduce(
                      (result, field) => {
                        result[field] =
                          res.data?.registerWithAccount.errors[
                            field
                          ][0].message;
                        return result;
                      },
                      {}
                    )
                  );
                }
              })
              .catch(() => {
                setFieldValue("turnstileToken", "", false);
              })
              .finally(() => {
                setSubmitting(false);
              });
          }}
          loading={loading}
        />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
